// extracted by mini-css-extract-plugin
module.exports = {"noData":"analyticsChart_noData__2DSd2"};